import {VatService} from "../../../../classes/VatService";

export default {
    methods: {
        getVatService() {
            return (new VatService(new Date))
        },
    },
    computed: {
        isVatQualifier() {
            return this.instance.is_vat_qualifier
        },
        vatInclusivePricing() {
            return !this.instance.use_commercial_pricing
        },
    }
}